const selector = {
    btnCheckSerialNumber: '.js_action_check_tag',
    inputSerialNumber: '#serial_number_input',
    configuration: '#uputstvo',
    additionalBtns: '.additional-btns',
    lang: 'input[name="lang"]',
    captchaHolder: '#captcha_holder',
    reloadCaptcha: '#reload_captcha',
};

export { selector };